import linklind from "../media/linklind.png";
import github from "../media/github.png";
import styles from "../css/home.module.css";
export const Home = () => {
  return (
    <div>
      <div id="home" className={styles.container}>
        <div style={{ flex: "1" }} className={styles.firstChild}>
          <div className={styles.emoji}>
            <p>Hello, My name is</p>
          </div>
          <div>
            <h1 className={styles.text}>Vinayak Hiwse</h1>
          </div>
          <div className={styles.para1}>
            <img
              src="https://readme-typing-svg.herokuapp.com?font=Anton&size=22&pause=1000&color=E4002B&width=435&lines=I'm a+FUll+Stack+Developer.;I'm a+Mern+Stack+Developer.;I'm a+React+Developer."
              alt="Typing SVG"
            />
          </div>
          <div className={styles.para}>
            <p>
              Here you will find more information about me, what I do , and my
              current skills mostly in terms of programming and technology
            </p>
          </div>
          <div>
            <button
              onClick={() => {
                window.open(
                  "https://drive.google.com/drive/folders/1MvFHUOfZw7v6MLp6LJO704a6DS3fQvOW?usp=share_link",
                  "_blank"
                );
              }}
              className={styles.resumeBtn}
            >
              Resume
            </button>
          </div>
          <div className={styles.iconDiv}>
            <a
              target="_blank"
              rel="noreferrer"
              style={{ display: "block" }}
              href="https://linkedin.com/in/vinayak-hiwse-467646219/"
            >
              <img src={linklind} alt="" />
            </a>
            <a
              style={{ display: "block" }}
              target="_blank"
              rel="noreferrer"
              href="https://github.com/Vicky160898/"
            >
              <img src={github} alt="" />
            </a>
          </div>
        </div>
        <div className={styles.secondChild}>
          <img
            src="https://camo.githubusercontent.com/8de2b97c3fffd143096c40537845b307bca30459a4c069523ba17516e42d3a91/68747470733a2f2f746f70646576732e6f72672f696d616765732f736974652f73657276696365732f7765626465762f6865726f2d62672e737667"
            alt="profile_img"
          />
        </div>
      </div>
    </div>
  );
};
